<div class="relative w-full max-w-xl max-h-[90vh] bg-white rounded-2xl shadow-xl shadow-black/10 ring-1 ring-black/5 overflow-hidden flex flex-col">
  <!-- Close -->
  <button
    class="absolute top-3 right-3 inline-flex h-9 w-9 items-center justify-center rounded-full bg-white/80 hover:bg-white text-slate-500 hover:text-slate-700 ring-1 ring-black/5 transition z-10"
    (click)="cancelar()"
    aria-label="Cerrar"
  >
    <svg class="h-5 w-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
      <path d="M6 6l12 12M18 6L6 18" stroke-width="2" stroke-linecap="round" />
    </svg>
  </button>

  <!-- Header -->
  <div class="px-6 pt-6 pb-4 bg-gradient-to-b from-slate-50 to-white">
    <div class="flex items-start gap-3">
      <div>
        <h3 class="text-xl font-semibold leading-tight text-slate-900">
          {{ tituloModal }}
        </h3>
        <p class="text-sm text-slate-500">
          {{ subtituloModal }}
        </p>
      </div>
    </div>
  </div>

  <!-- Body (scrollable) -->
  <div class="px-6 pb-6 overflow-y-auto flex-1" style="scrollbar-gutter: stable">
    <form (ngSubmit)="guardarHistorico()" class="space-y-6">
      <!-- Selector de título existente o nuevo (solo si NO está en modo edición de histórico) -->
      <div *ngIf="historico.length > 0 && !modoEdicionHistorico">
        <label class="block text-sm font-medium text-slate-700 mb-2">Selecciona una opción</label>
        <div class="space-y-2">
          <!-- Opción: Crear nuevo -->
          <label
            class="flex items-center gap-3 p-3 rounded-xl border-2 cursor-pointer transition"
            [class.border-purple-300]="!modoEdicion"
            [class.bg-purple-50]="!modoEdicion"
            [class.border-slate-200]="modoEdicion"
          >
            <input
              type="radio"
              name="tipoHistorico"
              [value]="false"
              [(ngModel)]="modoEdicion"
              class="h-4 w-4 text-purple-600"
            />
            <span class="font-medium text-slate-700">Crear nuevo título de histórico</span>
          </label>

          <!-- Opción: Agregar a existente -->
          <label
            class="flex items-center gap-3 p-3 rounded-xl border-2 cursor-pointer transition"
            [class.border-purple-300]="modoEdicion"
            [class.bg-purple-50]="modoEdicion"
            [class.border-slate-200]="!modoEdicion"
          >
            <input
              type="radio"
              name="tipoHistorico"
              [value]="true"
              [(ngModel)]="modoEdicion"
              class="h-4 w-4 text-purple-600"
            />
            <span class="font-medium text-slate-700">Agregar eventos a título existente</span>
          </label>
        </div>
      </div>

      <!-- Dropdown de títulos existentes (solo si modoEdicion = true y NO está en modo edición histórico) -->
      <div *ngIf="modoEdicion && historico.length > 0 && !modoEdicionHistorico">
        <label class="block text-sm font-medium text-slate-700 mb-1">Selecciona el título *</label>
        <select
          class="w-full rounded-xl border border-slate-200 bg-white px-3.5 py-2.5 text-slate-900 outline-none focus:ring-4 focus:ring-purple-100 focus:border-purple-300 transition"
          [(ngModel)]="indiceHistoricoSeleccionado"
          name="tituloExistente"
          required
          (ngModelChange)="onTituloSeleccionadoChange()"
        >
          <option [value]="null" disabled>-- Selecciona un título --</option>
          <option *ngFor="let hist of historico; let idx = index" [value]="idx">
            {{ hist.titulo }}
          </option>
        </select>
      </div>

      <!-- Campo de título (si está en modo edición histórico O modo nuevo) -->
      <div *ngIf="modoEdicionHistorico || !modoEdicion">
        <label class="block text-sm font-medium text-slate-700 mb-1">Título del histórico *</label>
        <input
          type="text"
          class="w-full rounded-xl border border-slate-200 bg-white px-3.5 py-2.5 text-slate-900 placeholder-slate-400 outline-none focus:ring-4 focus:ring-purple-100 focus:border-purple-300 transition"
          [(ngModel)]="nuevoHistorico.titulo"
          name="titulo"
          required
          placeholder="Ej. Complicaciones postoperatorias"
        />
      </div>

      <!-- Eventos -->
      <div>
        <div class="flex items-center justify-between mb-2">
          <label class="block text-sm font-medium text-slate-700">Complicaciones / eventos</label>
          <button
            type="button"
            class="inline-flex items-center gap-1.5 rounded-lg bg-[#AE91E3] text-white text-xs px-3 py-1.5 hover:bg-[#9F7FDB] transition shadow-sm shadow-purple-500/25"
            (click)="agregarEventoHistorico()"
          >
            <svg class="h-4 w-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path d="M12 6v12M6 12h12" stroke-width="2" stroke-linecap="round" />
            </svg>
            Agregar
          </button>
        </div>

        <div class="space-y-3">
          <div
            *ngFor="let evento of nuevoHistorico.eventos; let i = index"
            class="rounded-xl ring-1 ring-slate-200 bg-white/80 p-4"
          >
            <div class="grid grid-cols-1 md:grid-cols-2 gap-3">
              <div>
                <label class="text-xs font-medium text-slate-600">Fecha *</label>
                <input
                  type="date"
                  class="w-full mt-1 rounded-lg border border-slate-200 bg-white px-3 py-2 text-slate-900 outline-none focus:ring-4 focus:ring-purple-100 focus:border-purple-300 transition"
                  [(ngModel)]="evento.fecha"
                  [name]="'fecha' + i"
                  required
                />
              </div>
              <div>
                <label class="text-xs font-medium text-slate-600">Nombre de la complicación *</label>
                <input
                  type="text"
                  class="w-full mt-1 rounded-lg border border-slate-200 bg-white px-3 py-2 text-slate-900 outline-none focus:ring-4 focus:ring-purple-100 focus:border-purple-300 transition"
                  [(ngModel)]="evento.nombre"
                  [name]="'nombre' + i"
                  required
                  placeholder="Ej. Hemorragia leve"
                />
              </div>
              <div class="md:col-span-2">
                <label class="text-xs font-medium text-slate-600">Descripción (opcional)</label>
                <input
                  type="text"
                  class="w-full mt-1 rounded-lg border border-slate-200 bg-white px-3 py-2 text-slate-900 outline-none focus:ring-4 focus:ring-purple-100 focus:border-purple-300 transition"
                  [(ngModel)]="evento.descripcion"
                  [name]="'descripcion' + i"
                  placeholder="Detalles, evolución, notas…"
                />
              </div>

              <!-- Mostrar paraclínico asociado en modo edición -->
              <div *ngIf="modoEdicionHistorico && evento.paraclinico" class="md:col-span-2">
                <label class="text-xs font-medium text-slate-600 mb-1 block">Paraclínico asociado</label>
                <div class="flex items-center gap-2 p-3 bg-purple-50 rounded-lg border border-purple-200">
                  <svg
                    class="w-4 h-4 text-purple-600 flex-shrink-0"
                    fill="none"
                    stroke="currentColor"
                    viewBox="0 0 24 24"
                  >
                    <path
                      stroke-linecap="round"
                      stroke-linejoin="round"
                      stroke-width="2"
                      d="M9 12h6m-6 4h6m2 5H7a2 2 0 01-2-2V5a2 2 0 012-2h5.586a1 1 0 01.707.293l5.414 5.414a1 1 0 01.293.707V19a2 2 0 01-2 2z"
                    />
                  </svg>
                  <span class="text-sm text-slate-700 flex-1">{{ evento.paraclinico.nombre || 'Sin nombre' }}</span>
                  <button
                    type="button"
                    class="text-xs text-slate-500 hover:text-red-600 font-medium"
                    (click)="evento.paraclinico = undefined"
                  >
                    Desvincular
                  </button>
                </div>

                <!-- Opción para cambiar el paraclínico -->
                <div class="mt-2">
                  <button
                    type="button"
                    class="text-xs text-purple-600 hover:text-purple-700 font-medium"
                    (click)="mostrarSelectorParaclinico(i)"
                  >
                    Cambiar paraclínico asociado
                  </button>
                </div>

                <!-- Selector de paraclínico (aparece al hacer click en cambiar) -->
                <div *ngIf="eventoEditandoParaclinico === i && paraclinicosDisponibles.length > 0" class="mt-3">
                  <label class="text-xs font-medium text-slate-600">Selecciona un nuevo estudio</label>
                  <select
                    [(ngModel)]="paraclinicoTemporal"
                    [name]="'paraclinicoEdit' + i"
                    class="w-full mt-1 rounded-lg border border-slate-200 bg-white px-3 py-2 text-slate-900 outline-none focus:ring-4 focus:ring-purple-100 focus:border-purple-300 transition"
                  >
                    <option [value]="null">-- Selecciona un estudio --</option>
                    <option *ngFor="let para of paraclinicosDisponibles" [value]="para.id">
                      [{{ para.tipo?.toUpperCase() || 'N/A' }}] {{ para.nombre || 'Sin nombre' }} -
                      {{ para.fecha | date : 'dd/MM/yyyy' }}
                    </option>
                  </select>
                  <div class="mt-2 flex gap-2">
                    <button
                      type="button"
                      class="text-xs px-3 py-1.5 bg-purple-600 text-white rounded-lg hover:bg-purple-700"
                      (click)="aplicarCambioParaclinico(i)"
                    >
                      Aplicar
                    </button>
                    <button
                      type="button"
                      class="text-xs px-3 py-1.5 border border-slate-300 text-slate-700 rounded-lg hover:bg-slate-50"
                      (click)="eventoEditandoParaclinico = null"
                    >
                      Cancelar
                    </button>
                  </div>
                </div>
              </div>

              <!-- Agregar paraclínico si no tiene uno en modo edición -->
              <div
                *ngIf="modoEdicionHistorico && !evento.paraclinico && paraclinicosDisponibles.length > 0"
                class="md:col-span-2"
              >
                <button
                  type="button"
                  class="text-xs text-purple-600 hover:text-purple-700 font-medium flex items-center gap-1"
                  (click)="mostrarSelectorParaclinico(i)"
                >
                  <svg class="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                    <path d="M12 6v12M6 12h12" stroke-width="2" stroke-linecap="round" />
                  </svg>
                  Asociar paraclínico a este evento
                </button>

                <!-- Selector de paraclínico -->
                <div *ngIf="eventoEditandoParaclinico === i" class="mt-3">
                  <label class="text-xs font-medium text-slate-600">Selecciona un estudio</label>
                  <select
                    [(ngModel)]="paraclinicoTemporal"
                    [name]="'paraclinicoAdd' + i"
                    class="w-full mt-1 rounded-lg border border-slate-200 bg-white px-3 py-2 text-slate-900 outline-none focus:ring-4 focus:ring-purple-100 focus:border-purple-300 transition"
                  >
                    <option [value]="null">-- Selecciona un estudio --</option>
                    <option *ngFor="let para of paraclinicosDisponibles" [value]="para.id">
                      [{{ para.tipo?.toUpperCase() || 'N/A' }}] {{ para.nombre || 'Sin nombre' }} -
                      {{ para.fecha | date : 'dd/MM/yyyy' }}
                    </option>
                  </select>
                  <div class="mt-2 flex gap-2">
                    <button
                      type="button"
                      class="text-xs px-3 py-1.5 bg-purple-600 text-white rounded-lg hover:bg-purple-700"
                      (click)="aplicarCambioParaclinico(i)"
                    >
                      Aplicar
                    </button>
                    <button
                      type="button"
                      class="text-xs px-3 py-1.5 border border-slate-300 text-slate-700 rounded-lg hover:bg-slate-50"
                      (click)="eventoEditandoParaclinico = null"
                    >
                      Cancelar
                    </button>
                  </div>
                </div>
              </div>
            </div>

            <!-- Checkbox: Asociar paraclínico (solo en modo nuevo o agregar eventos, no en editar histórico) -->
            <div
              *ngIf="!modoEdicionHistorico && i === nuevoHistorico.eventos.length - 1 && paraclinicosDisponibles.length > 0"
              class="mt-4"
            >
              <div class="flex items-center gap-2 p-3 bg-purple-50 rounded-lg">
                <input
                  type="checkbox"
                  [(ngModel)]="asociarParaclinico"
                  [name]="'asociarParaclinico' + i"
                  [id]="'asociarParaclinico' + i"
                  class="h-4 w-4 text-purple-600 rounded border-slate-300 focus:ring-purple-500"
                />
                <label [for]="'asociarParaclinico' + i" class="text-sm font-medium text-slate-700 cursor-pointer">
                  Asociar estudio paraclínico
                </label>
              </div>

              <!-- Dropdown selector (solo si checkbox activado) -->
              <div *ngIf="asociarParaclinico" class="mt-3">
                <label class="text-xs font-medium text-slate-600">Selecciona el estudio *</label>
                <select
                  [(ngModel)]="paraclinicoSeleccionadoId"
                  [name]="'paraclinicoId' + i"
                  class="w-full mt-1 rounded-lg border border-slate-200 bg-white px-3 py-2 text-slate-900 outline-none focus:ring-4 focus:ring-purple-100 focus:border-purple-300 transition"
                >
                  <option [value]="null">-- Selecciona un estudio --</option>
                  <option *ngFor="let para of paraclinicosDisponibles" [value]="para.id">
                    [{{ para.tipo?.toUpperCase() || 'N/A' }}] {{ para.nombre }} -
                    {{ para.fecha | date : 'dd/MM/yyyy' }}
                  </option>
                </select>
              </div>
            </div>

            <div class="mt-3 flex justify-end">
              <button
                type="button"
                class="text-xs font-medium text-rose-600 hover:text-rose-700"
                (click)="eliminarEventoHistorico(i)"
              >
                Eliminar
              </button>
            </div>
          </div>

          <div *ngIf="nuevoHistorico.eventos.length === 0" class="text-center py-6 text-slate-500 text-sm bg-slate-50 rounded-xl">
            No hay eventos. Haz clic en "Agregar" para añadir uno.
          </div>
        </div>
      </div>
    </form>
  </div>

  <!-- Footer (sticky) -->
  <div
    class="mt-auto px-6 py-4 bg-white/90 backdrop-blur border-t border-slate-200 flex items-center justify-end gap-2"
  >
    <button
      type="button"
      class="px-4 py-2.5 rounded-xl border border-slate-200 text-slate-700 hover:bg-slate-50 transition"
      (click)="cancelar()"
    >
      Cancelar
    </button>
    <button
      type="button"
      class="px-4 py-2.5 rounded-xl bg-[#AE91E3] text-white hover:bg-[#9F7FDB] disabled:opacity-60 disabled:cursor-not-allowed transition shadow-md shadow-purple-500/25"
      [disabled]="!puedeGuardar()"
      (click)="guardarHistorico()"
    >
      {{ modoEdicionHistorico ? 'Actualizar histórico' : 'Guardar' }}
    </button>
  </div>
</div>
